var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolBorderless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 24L5.6 19.8C7.1 17.5 9.6 16 12.4 16H19C19 18.2 17.2 20 15 20H13",
    stroke: "#0057D9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H23L24.2 18.4C25.3 16.9 27.1 16 29 16L26.3 20.8C24.9 23.4 22.1 25 19.2 25C14.5 25 9.9 26.4 6 29",
    stroke: "#0057D9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1 12.9C24.2 12.3 24.3 11.6 24.3 11C24.3 10.3 24.2 9.7 24.1 9.1C23.1 9.2 22.1 8.8 21.6 7.8C21.1 6.9 21.2 5.8 21.8 5C20.9 4.1 19.7 3.4 18.4 3C18 3.9 17.1 4.6 16 4.6C14.9 4.6 14 3.9 13.6 3C12.3 3.4 11.2 4.1 10.2 5C10.8 5.8 10.9 6.9 10.4 7.8C9.90001 8.7 8.90001 9.2 7.90001 9.1C7.70001 9.7 7.70001 10.3 7.70001 11C7.70001 11.7 7.80001 12.3 7.90001 12.9",
    stroke: "#0057D9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 13C18.7 12.5 19 11.8 19 11C19 9.3 17.7 8 16 8C14.3 8 13 9.3 13 11C13 11.8 13.3 12.5 13.8 13",
    stroke: "#0057D9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolBorderless);
export default __webpack_public_path__ + "static/media/icon-sol-borderless.3c3589c26f40308198b83fc25fb4a317.svg";
export { ForwardRef as ReactComponent };